import type { UpgradeDef } from '../types';
import { MINING_UPGRADES, SKILL_NAME as MINING_SKILL } from './upgrades/mining_upgrades';
import { FARMING_UPGRADES, SKILL_NAME as FARMING_SKILL } from './upgrades/farming_upgrades';
import { ECONOMY_UPGRADES, SKILL_NAME as ECONOMY_SKILL } from './upgrades/economy_upgrades';
import { CRAFTING_UPGRADES, SKILL_NAME as CRAFTING_SKILL } from './upgrades/crafting_upgrades';

const withCategory = <T extends UpgradeDef>(upgrades: T[], category: string): T[] =>
    upgrades.map(u => ({ ...u, category }));

export const UPGRADES: UpgradeDef[] = [
    ...withCategory(MINING_UPGRADES, MINING_SKILL),
    ...withCategory(FARMING_UPGRADES, FARMING_SKILL),
    ...withCategory(ECONOMY_UPGRADES, ECONOMY_SKILL),
    ...withCategory(CRAFTING_UPGRADES, CRAFTING_SKILL),
];
